import * as LotteryThaiService from '@/services/apis/lotteryThai'
const state = () => ({
  tab: 0,
  roundDate:[],
  roundDateSelect:''
})

const mutations = {
  setActiveTab(state, tab) {
    state.tab = tab
  },
  setRoundDate(state, roundDate) {
    state.roundDate = roundDate
  },
  setRoundDateSelect(state, roundDateSelect) {
    state.roundDateSelect = roundDateSelect
  }
}

const actions = {
  async getLotteryMemberList({}, params) {
    try {
      const res = await LotteryThaiService.getLotteryMemberList(params)
      return res.data
    } catch (err) {
      if (err.message) {
        throw JSON.parse(err.message)
      }
    }
  },
  async getLotteryLimitList({}, params) {
    try {
      const res = await LotteryThaiService.getLotteryLimitList(params)
      return res.data
    } catch (err) {
      if (err.message) {
        throw JSON.parse(err.message)
      }
    }
  },
  async addLotteryLimit({}, params) {
    try {
      const res = await LotteryThaiService.addLotteryLimit(params)
      return res.data
    } catch (err) {
      if (err.message) {
        throw JSON.parse(err.message)
      }
    }
  },
  async updateLotteryLimit({}, params) {
    try {
      const res = await LotteryThaiService.updateLotteryLimit(params)
      return res.data
    } catch (err) {
      if (err.message) {
        throw JSON.parse(err.message)
      }
    }
  },
  async getLotteryMemberResult({}, params) {
    try {
      const res = await LotteryThaiService.getLotteryMemberResult(params)
      return res.data
    } catch (err) {
      if (err.message) {
        throw JSON.parse(err.message)
      }
    }
  },
  async getLotteryRound({}, params) {
    try {
      const res = await LotteryThaiService.getLotteryRound()
      return res.data
    } catch (err) {
      if (err.message) {
        throw JSON.parse(err.message)
      }
    }
  },
   async getLotteryDashboard({}, params) {
    try {
      const res = await LotteryThaiService.getLotteryDashboard(params)
      return res.data
    } catch (err) {
      if (err.message) {
        throw JSON.parse(err.message)
      }
    }
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
}
